module.exports = __webpack_public_path__ + "img/IMG_2248_L_BlackMatted_MockedUp.f294c57a.jpg";